<template>
  <div class="modal chat-note-modal">
    <div class="overlay" @click="$parent.closeChatNoteModal()"></div>
    <div class="wrapper">
      <div class="container">
        <img
          class="close"
          @click="$parent.closeChatNoteModal()"
          src="./../images/close.svg"
        />
        <div class="form-container">
          <div class="title small">
            {{ $t("Please note!") }}
          </div>
          <div class="desc small">
            {{
              $t(
                "chat_moderation_notice"
              )
            }}
            <br /><br />
            {{
              $t(
                "chat_violation_consequence"
              )
            }}
            <br /><br />
            {{ $t("chat_prohibited_notice") }}
            <br /><br />
            <ol>
              <li class="desc small">
                {{
                  $t(
                    "chat_prohibited_personal_info"
                  )
                }}
              </li>
              <li class="desc small">
                {{
                  $t(
                    "chat_prohibited_violence"
                  )
                }}
              </li>
              <li class="desc small">
                {{
                  $t(
                    "chat_prohibited_harmful_content"
                  )
                }}
              </li>
            </ol>
            <br /><br />
            {{
              $t(
                "chat_agreement_prompt"
              )
            }}
          </div>
          <div class="buttons">
            <button class="button bordered-white" @click="leave">
              {{ $t("Leave") }}
            </button>
            <button class="button colored" @click="agree">
              {{ $t("Agree") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";

export default {
  name: "ChatNoteModal",
  props: ["chatNoteModalIsVisible"],
  data: function () {
    return {};
  },
  methods: {
    ...mapMutations("topics", ["ADD_CHAT_AGREED"]),
    ...mapActions("topics", ["goToTopics"]),
    agree() {
      this.ADD_CHAT_AGREED(this.$parent.currentTopicId);
      this.$parent.closeChatNoteModal();
    },
    leave() {
      this.$parent.closeChatNoteModal();
      this.goToTopics();
    },
  },
};
</script>
